module.exports = __webpack_public_path__ + "img/3.9fee25e7.jpg";